/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/typedef */
/* eslint-disable @typescript-eslint/no-explicit-any */
export class NextEnumValue {
  static of<T extends object>(e: T) {
    const values = Object.keys(e).reduce((acc: any[], curr, index, arr) => {
      if (index < arr.length / 2) acc.push(curr);
      return acc;
    }, []);
    return {
      next: <K extends keyof T>(v: T[K]) => values[(values.indexOf(v) + 1) % values.length],
    };
  }
}
